/**
 * Chemins de l'explorateur de donnees.
 *
 * Module **pur**, comme `admin/users/routes.ts` : le menu (`ui/navigation.ts`)
 * et l'ecran l'importent tous deux, et le chemin ecrit en clair aux deux endroits
 * se maintiendrait deux fois.
 *
 * Une seule route `/data/*` monte l'ecran (`MasterDetail` l'exige : deux routes
 * pour la liste et la fiche demonteraient la liste a chaque ouverture). La
 * selection vit dans l'URL :
 *
 *   /data                          aucun perimetre : on en saisit un
 *   /data/{babyId}                 perimetre, collection et filtres en `?…`
 *   /data/{babyId}/{entityId}      enregistrement ouvert dans le tiroir
 */

export const DATA_PATH = '/data';

export const DATA_ROUTE = '/data/*';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Le serveur n'accepte qu'un UUID ; refuser ici evite un aller-retour qui finirait en 404. */
export const isScopeId = (value: string): boolean => UUID.test(value.trim());

export const dataScopePath = (babyId: string): string => `${DATA_PATH}/${encodeURIComponent(babyId)}`;

/**
 * Enregistrement ouvert dans le tiroir de l'explorateur : le perimetre, le type de
 * collection (`pumping_session`, `milk_batch`…) et l'identifiant. Le type voyage en
 * `?collection=`, comme celui qu'ecrit l'ecran lui-meme.
 */
export const dataRecordPath = (babyId: string, type: string, entityId: string): string =>
  `${dataScopePath(babyId)}/${encodeURIComponent(entityId)}?collection=${encodeURIComponent(type)}`;

/** Perimetre porte par le chemin, ou `null` sur `/data` seul. */
export const scopeFromPath = (pathname: string): string | null => {
  if (!pathname.startsWith(`${DATA_PATH}/`)) {
    return null;
  }

  const segment = pathname.slice(DATA_PATH.length + 1).split('/')[0] ?? '';

  if (segment === '') {
    return null;
  }

  try {
    return decodeURIComponent(segment);
  } catch {
    return null;
  }
};
